import React, { ReactElement } from 'react'
import { Heading } from '@scentregroup/ui'
import styles from './index.module.scss'
import { Pill } from '@hub/pill'

interface FiltersLarge {
  children: ReactElement
  countDisplay: string
}

const FiltersLarge = ({
  children,
  countDisplay,
}: FiltersLarge): JSX.Element => (
  <div className={styles.filtersContainer}>
    <Heading
      type="megasmalldivider"
      className={styles.filtersHeading}
      id="filter-heading"
    >
      Filters
    </Heading>
    <div className={styles.countWrapper}>
      <Pill>{countDisplay}</Pill>
    </div>
    {children}
  </div>
)

export default FiltersLarge
